import { playbookSteps } from "../../../mocks/guaData";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

export default function Playbook() {
  return (
    <section id="playbook" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[0.4fr_0.6fr] lg:gap-14">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHead
              eyebrow="炒作剧本 · 机制还原"
              title={
                <>
                  从零到爆火，
                  <br />
                  一套常见的<span className="text-primary-500">五步剧本</span>
                </>
              }
              desc="并非所有热点都遵循同一剧本，但高热度事件往往共享相近的推进节奏。拆开来看，每一步都有迹可循。"
            />
            <Reveal delay={120}>
              <div className="rounded-xl border border-accent-200 bg-accent-50/70 p-5 text-sm leading-relaxed text-accent-900">
                <p className="flex items-center gap-2 font-semibold">
                  <i className="ri-error-warning-fill" aria-hidden="true"></i>
                  提醒
                </p>
                <p className="mt-2">
                  本图仅用于理解传播机制，帮助读者识别过度营销，并不代表认定某起具体事件属于人为炒作。真正理性吃瓜，是不预设立场地看待每一则瓜。
                </p>
              </div>
            </Reveal>
          </div>

          <div className="relative pl-2">
            <span
              className="absolute bottom-4 left-7 top-4 w-px bg-background-300"
              aria-hidden="true"
            ></span>
            <ol className="space-y-6">
              {playbookSteps.map((s, i) => (
                <li key={s.no}>
                  <Reveal delay={i * 80}>
                    <div className="relative flex gap-5">
                      <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 border-background-200 bg-background-50 font-heading text-lg font-black text-accent-600 shadow-sm">
                        {s.no}
                      </div>
                      <div className="flex-1 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300">
                        <h3 className="font-heading text-lg font-bold text-foreground-950">{s.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                        <p className="mt-3 inline-flex flex-wrap items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                          <i className="ri-eye-line" aria-hidden="true"></i>
                          {s.hint}
                        </p>
                      </div>
                    </div>
                  </Reveal>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}